import React from "react";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";
import { MdEmail, MdLocationOn, MdPhone } from "react-icons/md";
import "./Footer.css";

const Footer = () => {
  return (
    <>
      {/* Wave Shape Top Separator */}
      <div className="footer-wave">
        <svg
          viewBox="0 0 500 150"
          preserveAspectRatio="none"
          className="footer-wave-svg"
        >
          <path
            d="M0.00,49.98 C149.99,150.00 349.21,-49.98 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
            style={{ stroke: "none", fill: "#141313" }}
          ></path>
        </svg>
      </div>

      <footer className="footer">
        <div className="footer-top">
          {/* Brand Info */}
          <div className="footer-col brand-col">
            <div className="footer-logo">
              <img src="./Images/logo/cab.png" alt="Logo" />
            </div>
            <p className="footer-desc">
              Book reliable Tempo Travellers for city tours, weekend getaways,
              and outstation trips. Enjoy safe, comfortable, and hassle-free
              travel with professional drivers.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="/about-us">About Us</a></li>
              <li><a href="#">Tempo Traveller Booking</a></li>
              <li><a href="#">Tour Packages</a></li>
              <li><a href="#">FAQs</a></li>
              <li><a href="/b2b-cab-bus-rental-ratesheet">B2B Cab Bus Rental Ratesheet</a></li>
              <li><a href="/hyderabad-cab-bus-b2b-ratesheet">Hyderabad Cab Bus B2B Ratesheet</a></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h3>Our Services</h3>
            <ul>
              <li><a href="#">Tempo Traveller in Hyderabad</a></li>
              <li><a href="#">AC & Non-AC Travellers</a></li>
              <li><a href="#">Local City Rides</a></li>
              <li><a href="#">Outstation Travel</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col contact-col">
            <h3>Contact Info</h3>
            <p><MdPhone /> +91-9701238500</p>
            <p><MdEmail /> booking@hyderabadtoursandtravels.com</p>
            <p><MdLocationOn /># 5 - 9 - 101/D, Assembly Metro Station, Opp. Public Gardens, Nampally, Hyderabad - 500001</p>
          </div>
        </div>

        {/* Newsletter & Social Row */}
        <div className="footer-extra">
          {/* Social Media */}
          <div className="social-col">
            <h3>Let's Connect</h3>
            <div className="footer-socials">
              <a href="#"><FaFacebookF /></a>
              <a href="#"><FaLinkedinIn /></a>
              <a href="#"><FaInstagram /></a>
              <a href="#"><FaYoutube /></a>
            </div>
          </div>

          {/* Newsletter */}
          <div className="newsletter-col">
            <h3>Subscribe</h3>
            <p>Stay updated with our latest offers & travel news.</p>
            <form className="newsletter-form">
              <input type="email" placeholder="Enter your email" />
              <button type="submit">Subscribe</button>
            </form>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Tempo Travellers. All Rights Reserved.</p>
          <p>Designed & Developed by<a href="https://www.eweblink.net/" target="black" style={{ textDecoration: "none" }}> <span>eWeblink</span></a></p>
        </div>
      </footer>

{/* Floating WhatsApp Button */}
<a
  href="https://wa.me/919999999999"
  className="whatsapp-float"
  target="_blank"
  rel="noopener noreferrer"
  aria-label="Chat on WhatsApp"
>
  <FaWhatsapp className="whatsapp-icon" />
</a>

    </>
  );
};

export default Footer;
